export default function(){
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://apps.bazaarvoice.com/deployments/mummnapa/main_site/production/en_US/bv.js';
    document.querySelectorAll('head')[0].appendChild(script);
}